<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="success" dark v-bind="attrs" v-on="on">
        <!-- <v-icon>fas fa-plus</v-icon> -->
        TRANSFER TO
      </v-btn>
    </template>
    <v-card>
      <!-- <v-card-title> -->
      <v-toolbar color="warning">
        <v-badge
          color="error darken-1"
          overlap
          :content="TotalQtyInCart.toLocaleString()"
        >
          <v-icon color="white">fas fa-cart-arrow-down</v-icon>
        </v-badge>

        <v-spacer></v-spacer>
        <v-btn @click="close" icon color="white">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- </v-card-title> -->
      <v-card-text class="pt-5">
        <v-form v-model="valid" ref="TransferForm">
          <BaseDate
            v-model="TranDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>
          <v-text-field
            outlined
            readonly
            name="CostFild"
            label="Total Costs"
            :value="TotalCosts.toLocaleString()"
            id="CostFildid"
          ></v-text-field>
          <v-text-field
            outlined
            readonly
            name="CostFild"
            label="Total Selling"
            :value="TotalPriceInCart.toLocaleString()"
            id="CostFildid"
          ></v-text-field>
          <v-select
            :rules="[v => !!v || 'Choose To Branch']"
            outlined
            item-text="BranchName"
            item-value="_id"
            :items="branches"
            v-model="toBranch"
            label="TO BRANCH"
          ></v-select>
        </v-form>
        <p v-if="ErrMsg" class="text-center error--text">{{ ErrMsg }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="isLoading && valid"
          color="success"
          @click="OnSavePayment"
          :disabled="!valid"
        >
          {{ "Save & Print" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
// import printComp from "./printSale";

export default {
  components: {
    // PrintSale: () => import("../printSale")
    // PrintSale: printComp
  },
  props: {
    TotalPriceInCart: { type: Number, required: true },
    SellType: { type: String, required: true },
  },

  data() {
    return {
      OrderPrint: "",
      toBranch: "",
      ErrMsg: "",
      print: false,
      dialog: false,
      valid: true,
      isLoading: false,
      TranDate: "",
    };
  },
  computed: {
    ...mapGetters(["FormattedCart", "GetBranches", "UsersToken"]),
    branches() {
      return this.GetBranches.filter(
        branch => branch._id != this.UsersToken.branchID
      );
    },
    orderCode: {
      get() {
        return this.OrderPrint;
      },
      set(v) {
        this.OrderPrint = v;
      },
    },
    paymentColor() {
      return this.SellType == "retail" ? "warning darken" : "teal darken-2";
    },

    TotalQtyInCart() {
      return this.FormattedCart.reduce((total, item) => {
        return (total += item.qty);
      }, 0);
    },
    TotalCosts() {
      const totalCost = this.FormattedCart.reduce((total, item) => {
        return (total +=
          item.cost * (item.qty / (item.retail ? item.UnitQty : 1)));
      }, 0).toFixed(1);
      return parseFloat(totalCost);
    },
  },

  methods: {
    close() {
      this.toBranch = "";
      this.ErrMsg = "";
      this.$refs.TransferForm.resetValidation();
      this.dialog = false;
    },

    OnSavePayment() {
      try {
        this.ErrMsg = "";
        if (this.$refs.TransferForm.validate()) {
          //   console.log("validated");

          let data = {
            ToBranch: this.toBranch,
            list: this.FormattedCart,
            date: this.TranDate,
            time: this.Current().time,
          };
          this.isLoading = true;
          this.$store
            .dispatch("INSERT_ONLY", { url: "/stock/transfer", data })
            .then(() => {
              // console.log(result);
              // this.orderCode = orderCode;
              this.isLoading = false;
              // this.print = true;
              this.$store.commit(
                "UDATE_PRODUCT",
                this.FormattedCart.map(cart => ({ ...cart, qty: -cart.qty }))
              );
              this.$store.commit("CLEAR_TO_CART");
              this.close();
            })
            .catch(err => {
              this.isLoading = false;
              this.ErrMsg = err;
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    FindCustome() {
      //   console.log("Called");
      this.clientID = null;
      this.Name = "";
      if (!this.phone) return;
      if (this.isLoading) return;
      this.isLoading = true;
      let PhoneKey = { url: "/customer/find", query: { phone: this.phone } };
      this.$store
        .dispatch("FIND_BY_VALUE", PhoneKey)
        .then(({ data }) => {
          //   console.log(data);
          if (!data) this.ShowName = true;
          else {
            this.Name = data.Name;
            this.clientID = data._id;
          }
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    },
  },
  mounted() {
    // this.$store.dispatch("loadBaraches");
  },
};
</script>
